import { OptionsMenuStorybook } from "@finanedi.es/storybook"
import { faPen, faTrashCan } from "@fortawesome/pro-light-svg-icons"
import { DepartamentoReadingFiltersDtoProps } from "api/DTOs/DepartamentoReadingFiltersDto"
import { TFunction } from "i18next"
import { Dispatch, SetStateAction } from "react"
import { ModalDepartamentosProps } from "../../views/Departamentos"

const USUARIOS_COLUMNS = (
  t: TFunction,
  openEditModal: Dispatch<SetStateAction<ModalDepartamentosProps>>,
  openDeleteModal: Dispatch<SetStateAction<string>>
) => {
  const columns = [
    {
      key: "nombre",
      header: `${t("gestionUsuarios.departamentos.table.departament")}`,
      field: "nombre",
      style: { width: "30%" },
      sortable: true,
      sortField: "nombre",
    },
    {
      key: "responsableNombres",
      header: `${t("gestionUsuarios.departamentos.table.responsible")}`,
      field: "responsableNombres",
      sortable: true,
      sortField: "DepartamentoUsuarios.Count(du=>du.Rol==2)",
      body: ({ responsableNombres }: DepartamentoReadingFiltersDtoProps) => {
        if (Array.isArray(responsableNombres)) {
          return responsableNombres
            .filter(Boolean)
            .map((responsableNombre) => String(responsableNombre).trim())
            .filter(Boolean)
            .join(", ")
        }
        return ""
      },
    },
    {
      key: "numeroUsuarios",
      header: `${t("gestionUsuarios.departamentos.table.user")}`,
      field: "numeroUsuarios",
      bodyClassName: "!tw-text-end",
      alignCol: "right",
      style: { width: "5%" },
      sortable: true,
      sortField: "DepartamentoUsuarios.Count",
    },
    {
      key: "actionButton",
      field: "actionButton",
      style: { width: "5%" },
      className: "!tw-p-2",
      bodyClassName: "!tw-w-auto tw-flex tw-justify-end",
      alignCol: "right",
      body: (rowData: DepartamentoReadingFiltersDtoProps) => (
        <OptionsMenuStorybook
          id={rowData.id}
          items={[
            {
              title: `${t("gestionUsuarios.departamentos.table.edit")}`,
              hasRedirect: true,
              action: () => {
                openEditModal({ rowData, isOpen: true })
              },
              icon: faPen,
            },
            {
              title: `${t("gestionUsuarios.departamentos.table.delete")}`,
              hasRedirect: true,
              className: "!tw-text-danger",
              action: () => {
                openDeleteModal(String(rowData?.id))
              },
              icon: faTrashCan,
            },
          ]}
          position='right'
        />
      ),
    },
  ]
  return columns
}

export default USUARIOS_COLUMNS
